export const addOns = {
  'serving-pot-big': {
    name: 'Serving Pot (Big)',
    price: 15,
    image: '/images/items/serving-pot-big.jpg'
  },
  'serving-pot-small': {
    name: 'Serving Pot (Small)',
    price: 10,
    image: '/images/items/serving-pot-small.jpg'
  },
  'cooking-pot-20l': {
    name: 'Cooking Pot 20L',
    price: 50,
    image: '/images/items/cooking-pot-20l.jpg'
  },
  'cooking-pot-15l': {
    name: 'Cooking Pot 15L',
    price: 45,
    image: '/images/items/cooking-pot-15l.jpg'
  },
  'cooking-pot-5l': {
    name: 'Cooking Pot 5L',
    price: 25,
    image: '/images/items/cooking-pot-5l.jpg'
  },
  'large-frying-pan': {
    name: 'Large Frying Pan',
    price: 30,
    image: '/images/items/large-frying-pan.jpg'
  },
  'silver-dish-big': {
    name: 'Big Silver Dish',
    price: 30,
    image: '/images/items/big-silver-dishes.jpg'
  },
  'silver-dish-small': {
    name: 'Small Silver Dish',
    price: 10,
    image: '/images/items/small-silver-dishes.jpg'
  },
  'shomeka': {
    name: 'Shomeka',
    price: 40,
    image: '/images/items/shomeka.jpg'
  },
  'large-cooking-stick': {
    name: 'Large Cooking Stick',
    price: 20,
    image: '/images/items/large-cooking-stick.jpg'
  },
  'brazier-big': {
    name: 'Big Brazier',
    price: 30,
    image: '/images/items/big-brazier.jpg'
  },
  'brazier-medium': {
    name: 'Medium Brazier',
    price: 10,
    image: '/images/items/medium-brazier.jpg'
  },
  'brazier-small': {
    name: 'Small Brazier',
    price: 5,
    image: '/images/items/small-brazier.jpg'
  },
  'plastic-bucket': {
    name: 'Clear Plastic Bucket',
    price: 'Contact us',
    image: '/images/items/plastic-bucket.jpg',
    requiresInquiry: true
  },
  'color-ribbon': {
    name: 'Color Ribbon',
    price: 'Custom',
    image: '/images/items/color-ribbon.jpg',
    requiresInquiry: true
  },
  'chaffing-dish-large': {
    name: 'Chaffing Dish (Large Rectangular)',
    price: 60,
    image: '/images/items/chaffing-dish-large.jpg'
  },
  'chaffing-dish-small': {
    name: 'Chaffing Dish (Small Circular)',
    price: 30,
    image: '/images/items/chaffing-dish-small.jpg'
  },

  // Music System Add-ons
  'genset-with-fuel': {
    name: 'Generator with Fuel (5 hours)',
    price: 1000,
    image: '/images/items/generator.jpg'
  },
  'projector': {
    name: 'Projector',
    price: 500,
    image: '/images/items/projector.jpg'
  }
};

export const packageData = {
  standard: {
    id: 'standard',
    name: 'Standard Package',
    price: 500,
    description: 'Ideal for small gatherings or family events',
    mainImage: '/images/packages/standard.jpg',
    items: [
      { name: 'Serving Pots', quantity: 28, image: '/images/items/servingpots40.jpg' },
      { name: 'Big Silver Dishes', quantity: 4, image: '/images/items/big-silver-dishes.jpg' },
      { name: 'Shomeka', quantity: 1, image: '/images/items/shomeka.jpg' },
      { name: 'Big Brazier', quantity: 1, image: '/images/items/big-brazier.jpg' }
    ]
  },
  premium: {
    id: 'premium',
    name: 'Premium Package',
    price: 700,
    description: 'Perfect for medium-sized events with light cooking needs',
    mainImage: '/images/packages/premium.jpg',
    items: [
      { name: 'Serving Pots', quantity: 35, image: '/images/items/servingpots40.jpg' },
      { name: 'Cooking Pot 20L', quantity: 1, image: '/images/items/cooking-pot-20l.jpg' },
      { name: 'Cooking Pots 5L', quantity: 2, image: '/images/items/cooking-pot-5l.jpg' },
      { name: 'Large Frying Pan', quantity: 1, image: '/images/items/large-frying-pan.jpg' },
      { name: 'Big Silver Dishes', quantity: 4, image: '/images/items/big-silver-dishes.jpg' },
      { name: 'Small Silver Dishes', quantity: 8, image: '/images/items/small-silver-dishes.jpg' },
      { name: 'Shomeka', quantity: 1, image: '/images/items/shomeka.jpg' },
      { name: 'Large Cooking Stick', quantity: 1, image: '/images/items/large-cooking-stick.jpg' },
      { name: 'Big Brazier', quantity: 1, image: '/images/items/big-brazier.jpg' }
    ]
  },
  deluxe: {
    id: 'deluxe',
    name: 'Deluxe Package',
    price: 1000,
    description: 'A comprehensive solution for large-scale events or high-end functions',
    mainImage: '/images/packages/deluxe.jpg',
    items: [
      { name: 'Serving Pots', quantity: 40, image: '/images/items/servingpots40.jpg' },
      { name: 'Cooking Pots 20L', quantity: 2, image: '/images/items/cooking-pot-20l.jpg' },
      { name: 'Cooking Pots 15L', quantity: 2, image: '/images/items/cooking-pot-15l.jpg' },
      { name: 'Cooking Pots 5L', quantity: 4, image: '/images/items/cooking-pot-5l.jpg' },
      { name: 'Large Frying Pans', quantity: 2, image: '/images/items/large-frying-pan.jpg' },
      { name: 'Big Silver Dishes', quantity: 4, image: '/images/items/big-silver-dishes.jpg' },
      { name: 'Small Silver Dishes', quantity: 8, image: '/images/items/small-silver-dishes.jpg' },
      { name: 'Shomeka', quantity: 2, image: '/images/items/shomeka.jpg' },
      { name: 'Large Cooking Sticks', quantity: 2, image: '/images/items/large-cooking-stick.jpg' },
      { name: 'Big Braziers', quantity: 2, image: '/images/items/big-brazier.jpg' },
      { name: 'Color Ribbon of your choice', quantity: 1, image: '/images/items/color-ribbon.jpg' },
      { name: 'Clear Plastic Buckets', quantity: 2, image: '/images/items/plastic-bucket.jpg' }
    ]
  },
  music: {
    id: 'music',
    name: 'Music System Package',
    price: 3500,
    description: 'Professional sound system setup for events with powerful speakers and expert technician support',
    mainImage: '/images/packages/music-system.jpg',
    items: [
      { name: 'Amplifier (2500W)', quantity: 1, image: '/images/items/amplifier.jpg' },
      { name: 'Professional Mixer', quantity: 1, image: '/images/items/mixer.jpg' },
      { name: 'Speakers (16000W)', quantity: 2, image: '/images/items/speaker-16k.jpg' },
      { name: 'Speakers (14000W)', quantity: 2, image: '/images/items/speaker-14k.jpg' },
      { name: 'Speakers (8000W)', quantity: 2, image: '/images/items/speaker-8k.jpg' },
      { name: 'Wireless Microphones with Transmitter', quantity: 2, image: '/images/items/wireless-mic-set.jpg' },
      { name: 'Professional Technician', quantity: 1, image: '/images/items/technician.jpg' }
    ]
  }
};
